import { isFieldPersisted, } from '@rammetec/data-access';
import { SERVICE_FILLED_NAMES } from './serviceFilledFields.js';
function isEmptyValue(value) {
    if (value === undefined || value === null)
        return true;
    if (typeof value === 'string' && value.trim() === '')
        return true;
    return false;
}
/**
 * Descriptor field names that a writer may supply — excludes service-stamped,
 * virtual, and group-inactive fields (`isFieldPersisted`, same rule as the form
 * / import path via `useActiveFieldGroups`).
 */
export function writableDescriptorFieldNames(descriptor, activeGroups = []) {
    const names = [];
    for (const field of descriptor.fields) {
        if (SERVICE_FILLED_NAMES.has(field.name))
            continue;
        if (!isFieldPersisted(field, activeGroups))
            continue;
        names.push(field.name);
    }
    return names;
}
/**
 * L0 field list for a create / full-record validate (`patch` against merge).
 * Omits empty `autoNumber` fields — the sequence / caller fills them later.
 */
export function descriptorFieldsForCreateValidation(descriptor, values, activeGroups = []) {
    const record = values;
    return writableDescriptorFieldNames(descriptor, activeGroups).filter((name) => {
        const field = descriptor.fields.find((f) => f.name === name);
        if (!field)
            return false;
        if (field.autoNumber === true && isEmptyValue(record[name]))
            return false;
        return true;
    });
}
/**
 * L0 field list for a partial `update` payload: only keys present on `values`.
 * Empty `{}` (version bump) → no fields → L0 is a no-op.
 */
export function descriptorFieldsForPartialUpdateValidation(descriptor, values, activeGroups = []) {
    const present = new Set(Object.keys(values));
    return descriptorFieldsForCreateValidation(descriptor, values, activeGroups).filter((name) => present.has(name));
}
/** Whether a field is service-filled (convenience for callers). */
export function isServiceFilledField(field) {
    return SERVICE_FILLED_NAMES.has(field.name);
}
//# sourceMappingURL=writableDescriptorFields.js.map